import React, { useState } from 'react';
import { Info, MapPin, Clock, ChevronRight, X, CheckCircle, Share2, ArrowLeft, Copy, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const WhatsAppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="#25D366"/>
  </svg>
);

const TelegramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.417 15.182l-.396 5.584c.568 0 .814-.244 1.11-.537l2.662-2.552 5.518 4.041c1.012.564 1.725.267 2.02-.956l3.638-17.057c.375-1.656-.606-2.294-1.536-1.886L1.757 9.728c-1.594.638-1.578 1.536-.272 1.95l5.454 1.705 12.673-7.982c.616-.387 1.185-.184.72.225z"
      fill="#0088CC"
    />
  </svg>
);

const RedditIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485l-2.286 2.286C.775 23.225 1.097 24 1.738 24H12c6.627 0 12-5.373 12-12S18.627 0 12 0Zm4.388 3.199c1.104 0 1.999.895 1.999 1.999 0 1.105-.895 2-1.999 2-.946 0-1.739-.657-1.947-1.539v.002c-1.147.162-2.032 1.15-2.032 2.341v.007c1.776.067 3.4.567 4.686 1.363.473-.363 1.064-.58 1.707-.58 1.547 0 2.802 1.254 2.802 2.802 0 1.117-.655 2.081-1.601 2.531-.088 3.256-3.637 5.876-7.997 5.876-4.361 0-7.905-2.617-7.998-5.87-.954-.447-1.614-1.415-1.614-2.538 0-1.548 1.255-2.802 2.803-2.802.645 0 1.239.218 1.712.585 1.275-.79 2.881-1.291 4.64-1.365v-.01c0-1.663 1.263-3.034 2.88-3.207.188-.911.993-1.595 1.959-1.595Zm-8.085 8.376c-.784 0-1.459.78-1.506 1.797-.047 1.016.64 1.429 1.426 1.429.786 0 1.371-.369 1.418-1.385.047-1.017-.553-1.841-1.338-1.841Zm7.406 0c-.786 0-1.385.824-1.338 1.841.047 1.017.634 1.385 1.418 1.385.785 0 1.473-.413 1.426-1.429-.046-1.017-.721-1.797-1.506-1.797Zm-3.703 4.013c-.974 0-1.907.048-2.77.135-.147.015-.241.168-.183.305.483 1.154 1.622 1.964 2.953 1.964 1.33 0 2.47-.81 2.953-1.964.057-.137-.037-.29-.184-.305-.863-.087-1.795-.135-2.769-.135Z" fill="#FF4500"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.428c0-3.008 1.792-4.669 4.532-4.669 1.313 0 2.686.235 2.686.235v2.953h-1.514c-1.492 0-1.955.925-1.955 1.875v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      fill="#1877F2"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="instagramGradient" cx="30%" cy="30%" r="70%">
        <stop offset="0%" style={{ stopColor: '#feda75' }} />
        <stop offset="25%" style={{ stopColor: '#fa7e1e' }} />
        <stop offset="50%" style={{ stopColor: '#d62976' }} />
        <stop offset="75%" style={{ stopColor: '#962fbf' }} />
        <stop offset="100%" style={{ stopColor: '#4f5bd5' }} />
      </radialGradient>
    </defs>
    <path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077" fill="url(#instagramGradient)" />
  </svg>
);


const EventCard = ({ event, onDetailsClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  const categoryStyles = {
    Event: 'bg-blue-500/10 text-blue-500',
    Workshop: 'bg-green-500/10 text-green-500',
    Volunteer: 'bg-yellow-500/10 text-yellow-500',
    'Meet Up': 'bg-purple-500/10 text-purple-500',
    Program: 'bg-teal-500/10 text-teal-500',  
    Seminar: 'bg-orange-500/10 text-orange-500',  
  };

  // Safe domains list
  const safeDomains = [
    'forms.gle',
    'docs.google.com',
    'forms.office.com',
    'zoom.us',
    'facebook.com',
    'instagram.com'
  ];

  const truncateDescription = (text, maxLength) => {
    if (!text) return 'No description available';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleDetailsClick = () => {
    setIsModalOpen(true);
    if (onDetailsClick) onDetailsClick();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsShareModalOpen(false);
    setIsWarningModalOpen(false);
    setShowToast(false);

  };

  const isSafeDomain = (url) => {
    if (!url) return false;
    try {
      const hostname = new URL(url).hostname.toLowerCase();
      return safeDomains.some(domain => hostname === domain || hostname.endsWith(`.${domain}`));
    } catch (e) {
      return false;
    }
  };

  const handleJoinClick = () => {
    if (!event?.link) {
      navigate(`/events/${event.id}`);
      return;
    }

    const isUnverified = [1, 2, 3].includes(organizer.verified);
    const isSafe = isSafeDomain(event.link);

    if (isUnverified && !isSafe) {
      setIsModalOpen(false);
      setIsWarningModalOpen(true);
    } else {
      window.open(event.link, '_blank');
    }
  };

  const handleWarningProceed = () => {
    setIsWarningModalOpen(false);
    if (event?.link) {
      window.open(event.link, '_blank');
    }
  };

  const handleWarningCancel = () => {
    setIsWarningModalOpen(false);
    setIsModalOpen(true);
  };

  const handleShareClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
    setIsShareModalOpen(true);

  };

  const handleCloseShareModal = () => {
    setIsShareModalOpen(false);
    setShowToast(false);

  };

  const handleBackToDetails = () => {
    setIsShareModalOpen(false);
    setIsModalOpen(true);
    setShowToast(false);

  };

  const handleCopyLink = () => {
    const shareUrl = `${window.location.origin}/events/${event.id}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    });
  };

  const shareToSocial = (platform) => {
    const shareUrl = encodeURIComponent(`${window.location.origin}/events/${event.id}`);
    const title = encodeURIComponent(event.title || event.name || 'Event');
    let url;
    switch (platform) {
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${title}%20${shareUrl}`;
        break;
      case 'instagram':
        url = `https://www.instagram.com/`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${shareUrl}&text=${title}`;
        break;
      case 'reddit':
        url = `https://www.reddit.com/submit?url=${shareUrl}&title=${title}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
        break;
      default:
        return;
    }
    window.open(url, '_blank');
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return { month: 'N/A', day: 'N/A' };
    if (typeof dateInput === 'string') {
      const date = new Date(dateInput);
      if (isNaN(date.getTime())) return { month: 'N/A', day: 'N/A' };
      const month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
      const day = date.getDate().toString().padStart(2, '0');
      return { month, day };
    }
    return {
      month: dateInput.month || 'N/A',
      day: dateInput.day ? dateInput.day.toString().padStart(2, '0') : 'N/A',
    };
  };

  const eventDate = formatDate(event.date);
  const eventName = event.title || 'Untitled Event';
  const eventDescription = event.brief || event.description || 'No description available';
  const eventModalDescription = event.description || event.brief || 'No description available';
  const eventCategory = event.type || event.category || 'Event';
  const eventImage = event.banner || event.imageUrl || '/placeholder.jpg';
  const eventTime = event.time || 'N/A';
  const eventLocation = event.location || 'N/A';
  const eventLink = event.link || null;
  const organizer = event.organizer || {
    name: 'Unknown',
    avatar: '/placeholder-avatar.jpg',
    verified: 0,
  };


  return (
    <>
      {/* Event Card with scale-up effect */}
      <div
        className={`p-[2px] rounded-[16px] transition-all duration-300 bg-transparent`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className={`card w-full max-w-[350px] rounded-[16px] overflow-hidden bg-[#1A1A1A] shadow-md hover:shadow-xl transition-all duration-300 transform ${
            isHovered ? 'scale-105' : 'scale-100'
          } translate-y-[-4px] border-2 ${
            isHovered ? 'border-blue-500' : 'border-transparent'
          }`}
        >
          <div className="card-image relative w-full h-[220px]">
            <img src={eventImage} alt={eventName} className="w-full h-full object-cover" />
            <div className="date-badge absolute top-4 right-4 bg-gradient-to-br from-black/50 to-gray-800/50 text-white rounded-lg w-[60px] h-[60px] flex flex-col justify-center items-center font-semibold">
              <div className="month text-xs uppercase">{eventDate.month}</div>
              <div className="day text-lg">{eventDate.day}</div>
            </div>
          </div>

          <div className="card-content p-5">
            <span
              className={`px-2 py-1 rounded-full text-xs font-medium ${
                categoryStyles[eventCategory] || 'bg-gray-600/10 text-gray-400'
              }`}
            >
              {eventCategory}
            </span>

            <h2 className="event-title text-xl font-semibold text-gray-900 text-white mt-3 mb-2">
              {eventName}
            </h2>

            <div className="event-organizer flex items-center mb-4">
              <div className="organizer-avatar w-8 h-8 rounded-full mr-3 overflow-hidden">
                <img src={organizer.avatar || '/placeholder-avatar.svg'} alt={organizer.name} className="w-full h-full object-cover" />
              </div>
              <div className="text-sm font-medium text-gray-200 flex items-center">
                {organizer.name}
                {[4, 5, 6].includes(organizer.verified) && (
                  <span
                    className={`ml-1 ${
                      organizer.verified === 4
                        ? 'verified-badge-user'
                        : organizer.verified === 5
                        ? 'verified-badge-admin'
                        : 'verified-badge-community'
                    }`}
                  >
                    <CheckCircle className="text-blue-500" size={14} />
                  </span>
                )}
              </div>
            </div>

            <div className="event-details mb-4 text-sm text-gray-300">
              <div className="event-detail flex items-center mb-2">
                <Clock className="mr-2 text-gray-400" size={16} />
                <span>{eventTime}</span>
              </div>
              <div className="event-detail flex items-center">
                <MapPin className="mr-2 text-gray-400" size={16} />
                <span>{eventLocation}</span>
              </div>
            </div>

            <p className="event-description text-sm text-gray-300 mb-5 leading-6">
              {truncateDescription(eventDescription, 100)}
            </p>

            <div className="card-actions flex gap-3 mt-4">
              <button
                onClick={handleDetailsClick}
                className="flex-1 py-2 px-4 rounded-lg border border-gray-600 text-gray-300 bg-transparent hover:bg-gray-700 text-sm font-medium transition-colors duration-200 flex items-center justify-center"
              >
                <Info className="mr-2" size={16} />
                Details
              </button>
              <button
                onClick={handleJoinClick}
                className="flex-1 py-2 px-4 rounded-lg bg-blue-500 text-white hover:bg-blue-600 text-sm font-medium transition-colors duration-200 flex items-center justify-center"
              >
                Join
                <ChevronRight className="ml-2" size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Details Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50" role="presentation">
          <button
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={handleCloseModal}
            onKeyDown={(e) => e.key === 'Escape' && handleCloseModal()}
            aria-label="Close modal"
          />

          <div
            className="relative bg-[#1A1A1A] rounded-[16px] w-full max-w-[500px] p-8 shadow-2xl transform transition-all duration-300 scale-100 overflow-y-auto max-h-[90vh] custom-scrollbar"
            role="dialog"
            aria-modal="true"
          >
            <button
              onClick={handleCloseModal}
              onKeyDown={(e) => e.key === 'Enter' && handleCloseModal()}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-200 transition-colors duration-200 z-10"
              aria-label="Close"
            >
              <X size={20} />
            </button>

            <div className="relative mb-10">
              <img src={eventImage} alt={eventName} className="w-full h-64 object-cover rounded-lg" />
            </div>

            <h2 className="text-2xl font-semibold text-white mb-4">{eventName}</h2>

            <p className="text-sm text-gray-300 leading-6 mb-6">{eventModalDescription}</p>

            <div className="event-details text-sm text-gray-300 space-y-4 mb-6">
              <div className="flex items-center">
                <MapPin className="mr-3 text-blue-400" size={18} />
                <span>{eventLocation}</span>
              </div>
              <div className="flex items-center">
                <Clock className="mr-3 text-blue-400" size={18} />
                <span>
                  {eventDate.month} {eventDate.day}, {eventTime}
                </span>
              </div>
            </div>

            <div className="flex items-center mb-6">
              <img src={organizer.avatar || '/placeholder-avatar.svg'} alt={organizer.name} className="w-10 h-10 rounded-full mr-3" />
              <span className="text-sm font-medium text-gray-200 flex items-center">
                {organizer.name}
                {[4, 5, 6].includes(organizer.verified) && (
                  <span
                    className={`ml-1 ${
                      organizer.verified === 4
                        ? 'verified-badge-user'
                        : organizer.verified === 5
                        ? 'verified-badge-admin'
                        : 'verified-badge-community'
                    }`}
                  >
                    <CheckCircle className="text-blue-500" size={14} />
                  </span>
                )}
              </span>
            </div>

            <div className="mb-6">
              <button
                onClick={handleShareClick}
                className="w-full py-2 px-4 rounded-lg border border-gray-600 text-gray-300 bg-transparent hover:bg-gray-700 text-sm font-medium transition-colors duration-200 flex items-center justify-center"
                aria-label="Share this event"
              >
                <Share2 className="mr-2" size={16} />
                Share
              </button>
            </div>

            <div className="relative">
              <button
                onClick={handleJoinClick}
                className={`w-full py-2 px-4 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center justify-center group ${
                  eventLink
                    ? 'text-white bg-blue-500 hover:bg-blue-600'
                    : 'bg-gray-500 text-gray-300 cursor-not-allowed'
                }`}
                disabled={!eventLink}
              >
                Join
                <ChevronRight className="ml-2" size={16} />
              </button>
              {!eventLink && (
                <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 left-1/2 transform -translate-x-1/2">
                  Organizer didn’t provide a register link
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Warning Modal */}
      {isWarningModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50" role="presentation">
          <button
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={handleWarningCancel}
            onKeyDown={(e) => e.key === 'Escape' && handleWarningCancel()}
            aria-label="Close warning modal"
          />

          <div
            className="relative bg-[#1A1A1A] rounded-[16px] w-full max-w-[400px] p-6 shadow-2xl transform transition-all duration-300 scale-100 custom-scrollbar"
            role="dialog"
            aria-modal="true"
          >
            <button
              onClick={handleWarningCancel}
              onKeyDown={(e) => e.key === 'Enter' && handleWarningCancel()}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-200 transition-colors duration-200"
              aria-label="Close"
            >
              <X size={20} />
            </button>

            <div className="flex items-center mb-4">
              <AlertTriangle className="text-yellow-500 mr-3" size={24} />
              <h3 className="text-lg font-semibold text-white">Link Submitted by Unverified User</h3>
            </div>

            <p className="text#pragma once-sm text-gray-300 mb-4">
              This register link was submitted by an unverified user and may be unsafe. Our site is not responsible for external links.
            </p>

            <p className="text-sm text-gray-400 mb-6 break-all overflow-hidden text-ellipsis">{eventLink}</p>

            <div className="flex gap-3">
              <button
                onClick={handleWarningCancel}
                className="flex-1 py-2 px-4 rounded-lg border border-gray-600 text-gray-300 bg-transparent hover:bg-gray-700 text-sm font-medium transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleWarningProceed}
                className="flex-1 py-2 px-4 rounded-lg bg-blue-500 text-white hover:bg-blue-600 text-sm font-medium transition-colors duration-200"
              >
                Open Link
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Share Modal */}
      {isShareModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50" role="presentation">
          <button
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={handleCloseShareModal}
            onKeyDown={(e) => e.key === 'Escape' && handleCloseShareModal()}
            aria-label="Close share modal"
          />

          <div
            className="relative bg-[#1A1A1A] rounded-[16px] w-full max-w-[400px] p-6 shadow-2xl transform transition-all duration-300 scale-100 custom-scrollbar"
            role="dialog"
            aria-modal="true"
          >
            <div className="flex items-center justify-between mb-4">
              <button
                onClick={handleBackToDetails}
                onKeyDown={(e) => e.key === 'Enter' && handleBackToDetails()}
                className="text-gray-400 hover:text-gray-200 transition-colors duration-200"
                aria-label="Back to details"
              >
                <ArrowLeft size={20} />
              </button>
              <h3 className="text-lg font-semibold text-white">Share with friends</h3>
              <button
                onClick={handleCloseShareModal}
                onKeyDown={(e) => e.key === 'Enter' && handleCloseShareModal()}
                className="text-gray-400 hover:text-gray-200 transition-colors duration-200"
                aria-label="Close"
              >
                <X size={20} />
              </button>
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-300 mb-4">Share this link via</p>
              <div className="flex justify-between">
                <button
                  onClick={() => shareToSocial('telegram')}
                  className="flex flex-col items-center border-2 rounded-full p-0.5 border-transparent"
                  aria-label="Share on Telegram"
                >
                  <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center">
                    <TelegramIcon />
                  </div>
                  <span className="text-xs text-gray-300 mt-2">Telegram</span>
                </button>
                <button
                  onClick={() => shareToSocial('whatsapp')}
                  className="flex flex-col items-center border-2 rounded-full p-0.5 border-transparent"
                  aria-label="Share on WhatsApp"
                >
                  <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center">
                    <WhatsAppIcon />
                  </div>
                  <span className="text-xs text-gray-300 mt-2">WhatsApp</span>
                </button>
                <button
                  onClick={() => shareToSocial('reddit')}
                  className="flex flex-col items-center border-2 rounded-full p-0.5 border-transparent"
                  aria-label="Share on Reddit"
                >
                  <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center">
                    <RedditIcon />
                  </div>
                  <span className="text-xs text-gray-300 mt-2">Reddit</span>
                </button>
                <button
                  onClick={() => shareToSocial('facebook')}
                  className="flex flex-col items-center border-2 rounded-full p-0.5 border-transparent"
                  aria-label="Share on Facebook"
                >
                  <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center">
                    <FacebookIcon />
                  </div>
                  <span className="text-xs text-gray-300 mt-2">Facebook</span>
                </button>
                <button
                  onClick={() => shareToSocial('instagram')}
                  className="flex flex-col items-center border-2 rounded-full p-0.5 border-transparent"
                  aria-label="Share on Instagram"
                >
                  <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center">
                    <InstagramIcon />
                  </div>
                  <span className="text-xs text-gray-300 mt-2">Instagram</span>
                </button>
              </div>
            </div>

            <div>
              <hr className="border-t border-gray-600 mb-4" />
              <p className="text-sm text-gray-300 mb-3">Copy the Link</p>
              <div className="flex items-center bg-[#2A2A2A] rounded-lg p-2">
                <span className="text-sm text-gray-400 flex-1 truncate">{`${window.location.origin}/events/${event.id}`}</span>
                <button
                  onClick={handleCopyLink}
                  className="ml-2 text-gray-400 hover:text-gray-200"
                  aria-label="Copy event link"
                >
                  <Copy size={20} />
                </button>
              </div>
              {showToast && (
                <div className="mt-3 flex items-center gap-2 bg-green-500/10 text-green-400 rounded-lg px-3 py-2 shadow-md animate-fade-in-out">
                  <CheckCircle size={16} />
                  <span className="text-sm">Copied to clipboard</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};


export default EventCard;